// TEMPORARY workaround for a fragno defect -- remove once fragno ships the
// fix and shop-web bumps its fragno version (t-fragno-component-fixes.3).
// Re-checked fragno 1.17.0 and fragno 2.3.0: role="banner"
// still baked into the template in both.
//
// fragno-page-header's shadow-free (light DOM) template always renders
// <header role="banner">, with no attribute to suppress it. Every reskin page
// already has its own site-wide banner landmark from fragno-global-nav, so a
// page using fragno-page-header for its own title (store-page-v2,
// category-page-v2) ends up with two role="banner" landmarks -- an
// accessibility-landmark-navigation defect for screen-reader users.
//
// The role is baked into the component's template once, in its
// connectedCallback -- render() never touches it again -- so a one-time
// strip is enough; no MutationObserver needed. Must wait for DOMContentLoaded:
// Shakapacker defers pack scripts by default and the fragno pack tag precedes
// this one, but a deferred script still runs before DOMContentLoaded fires,
// which is the first point every fragno-page-header instance is guaranteed
// to exist.
document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll("fragno-page-header .fragno-page-header")
    .forEach((el) => {
      el.removeAttribute("role");
    });
});
